import { Box, Flex, Stack, Text } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";

interface ListItemCardProps {
  title: string;
  description?: string;
  logo?: React.ReactElement;
  rightIcon?: string;
  onClick?: () => void;
}

export const ListItemCard = (props: ListItemCardProps) => {
  const { title, description, logo, rightIcon, onClick } = props;
  return (
    <Flex
      onClick={onClick}
      align="center"
      justify="space-between"
      paddingX="spacing-sm"
      paddingY="spacing-xs"
      cursor="pointer"
      borderRadius="radius-sm"
      borderColor={"border.secondary"}
      _hover={{ background: "background.secondary" }}
    >
      <Flex align="center" gap="spacing-xs">
        {logo && (
          <Box
            padding="spacing-xs"
            borderRadius="radius-sm"
            background="background.secondary"
            boxSize="2.7rem"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {logo}
          </Box>
        )}
        <Stack gap="spacing-xxs">
          <Text textStyle="label/M/regular">{title}</Text>
          {description && (
            <Text textStyle="label/S/regular" color="foreground.secondary">
              {description}
            </Text>
          )}
        </Stack>
      </Flex>
      {rightIcon && <Icon color="foreground.primary" name={rightIcon} />}
    </Flex>
  );
};
